import { render, staticRenderFns } from "./ShokurekishoCareerEdit.vue?vue&type=template&id=ffae61b4&scoped=true"
import script from "./ShokurekishoCareerEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShokurekishoCareerEdit.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShokurekishoCareerEdit.vue?vue&type=style&index=0&id=ffae61b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffae61b4",
  null
  
)

export default component.exports